import {LinePlotDisplayRowFnType} from '../types';
import {LinePlotTemplateSettings} from '../workspaceTemplatesQueries';
import {
  getExcludeOutliersDisplayRow,
  getPointVisualizationMethodDisplayRow,
  getShowOriginalAfterSmoothingDisplayRow,
} from './dataSettingsDisplayValues';
import {
  getColorRunNamesDisplayRow,
  getCoordinateZoomingDisplayRow,
  getDisplayFullRunNameDisplayRow,
  getHighlightedCompanionRunOnlyDisplayRow,
  getShowLegendDisplayRow,
  getShowXRangeDisplayRow,
  getTooltipNumberOfRunsDisplayRow,
} from './displayPreferencesDisplayValues';
import {
  getGroupAggDisplayRow,
  getGroupSettingDisplayRow,
} from './groupingDisplayValues';
import {getMaxRunsDisplayRow} from './maxRunsDisplayValues';
import {getSmoothingWeightDisplayRow} from './smoothingDisplayValues';
import {
  getXAxisDisplayRow,
  getXAxisFormatDisplayRow,
  getXAxisMaxDisplayRow,
  getXAxisMinDisplayRow,
  getXLogScaleDisplayRow,
} from './xAxisDisplayValues';
import {
  getYAxisMaxDisplayRow,
  getYAxisMinDisplayRow,
  getYLogScaleDisplayRow,
} from './yAxisDisplayValues';

/**
 * Display functions for line plot template fields.
 * Note: smoothingType is handled separately via useSmoothingTypeDisplayRow hook
 * because it needs access to the backend smoothing feature flag.
 */
export const LINE_PLOT_TEMPLATE_DISPLAY_FNS: Partial<
  Record<keyof LinePlotTemplateSettings, LinePlotDisplayRowFnType>
> = {
  // X-axis settings
  xAxis: getXAxisDisplayRow,
  xLogScale: getXLogScaleDisplayRow,
  xAxisMin: getXAxisMinDisplayRow,
  xAxisMax: getXAxisMaxDisplayRow,
  xAxisFormat: getXAxisFormatDisplayRow,
  // Y-axis settings
  yLogScale: getYLogScaleDisplayRow,
  yAxisMin: getYAxisMinDisplayRow,
  yAxisMax: getYAxisMaxDisplayRow,
  // Smoothing settings
  smoothingWeight: getSmoothingWeightDisplayRow,
  showOriginalAfterSmoothing: getShowOriginalAfterSmoothingDisplayRow,
  // Runs settings
  maxRuns: getMaxRunsDisplayRow,
  pointVisualizationMethod: getPointVisualizationMethodDisplayRow,
  excludeOutliers: getExcludeOutliersDisplayRow,
  // Grouping settings
  useRunsTableGroupingInPanels: getGroupSettingDisplayRow,
  groupAgg: getGroupAggDisplayRow,
  // Display preferences
  colorRunNames: getColorRunNamesDisplayRow,
  displayFullRunName: getDisplayFullRunNameDisplayRow,
  showLegend: getShowLegendDisplayRow,
  showXRange: getShowXRangeDisplayRow,
  tooltipNumberOfRuns: getTooltipNumberOfRunsDisplayRow,
  coordinateZooming: getCoordinateZoomingDisplayRow,
  highlightedCompanionRunOnly: getHighlightedCompanionRunOnlyDisplayRow,
};
